<template>
  <div class="listaNcm">
    <el-button @click="getListaNcm()" size="mini" type="primary">Lista Completa NCM</el-button>

    <!-- DIALOG -->
    <el-dialog title="Tabela de NCM" :visible.sync="dialogNcmVisible">
    <el-row type="flex"  justify="left">
      <el-col :xs="24" :sm="24" :md="20" :lg="22" :xl="20"  >
        <el-form :inline="true" :model="formPesquisa" class="form-inline-pesquisa">
          <el-form-item label="">
            <el-input v-model="formPesquisa.pesquisa" placeholder="Pesquisa por...">
                  <el-button slot="append" @click="onSubmitPesquisa" icon="el-icon-search"></el-button>            
            </el-input>
          </el-form-item>
        </el-form>         
      </el-col>
    </el-row> 
      <el-table :data="gridData" highlight-current-row @current-change="handleCurrentChangeTable" v-loading="loading" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.7)" empty-text="Sem dados!" >
        <el-table-column property="id" label="id" width="150"></el-table-column>
        <el-table-column property="ncm" label="ncm" width="200"></el-table-column>
        <el-table-column property="descricao" label="Descrição"></el-table-column>
        <el-table-column property="ipi" label="IPI"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next"
        background
        :total="total"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

// const url = 'http://'+window.location.hostname+':8000/api';
const url = '/api';

export default {
  data() {
    return {
      gridData: [],
      dialogNcmVisible: false,
      total: 0,
      pageSize: 20,
      loading: true,
      currentPage: 1,
      formPesquisa: {
        pesquisa: "",
      },
    };
  },
  methods: {
    getListaNcm(com_em, ps) {
      this.loading = true;
      this.dialogNcmVisible = true;
      if (typeof com_em === "undefined") {
        com_em = 0;
        ps = this.pageSize;
      }
      axios
        .get(url+"/ncm/" + com_em + "/" + ps + "/", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.loading = false;
            this.gridData = resp.data["dados"];
            this.total = resp.data["total"];
            this.list = this.gridData.map((item) => {
              return {
                id: item.id,
                ncm: item.ncm,
                descricao: item.descricao.substr(0, 70),
              };
            });
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message: "Erro ao acessar os dados de NCM!" + err,
            type: "error",
          });
        });
    },
    //PESQUISA
    onSubmitPesquisa() {
      this.loading = true;
      let dados = {
        pesquisa: this.formPesquisa.pesquisa,
      };
      axios
        .post(
          url+"/ncm/0/" + this.pageSize,
          dados,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
            this.loading = false;
            this.gridData = response.data["dados"];
            this.total = response.data["total"];
            this.list = this.gridData.map((item) => {
              return {
                id: item.id,
                ncm: item.ncm,
                descricao: item.descricao.substr(0, 70),
              };
            });            
           this.currentPage = 1;
        })
        .catch((err) => {
          this.list = "erro" + err;
        });
    },
    //FIM PESQUISA
    //PAGINAÇÃO
    handleSizeChange: function (size) {
      this.pageSize = size;
      let comeca_em;
      if (this.currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (this.currentPage - 1) * this.pageSize;
      }

      this.getListaNcm(comeca_em, this.pageSize);
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      let comeca_em;
      if (currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (currentPage - 1) * this.pageSize;
      }

      this.getListaNcm(comeca_em, this.pageSize);
    },

    //FIM PAGINAÇÃO
    handleCurrentChangeTable(val) {
      this.currentRow = val;
      this.$emit('ncm-click',this.currentRow);
      this.dialogNcmVisible=false;
    },
  },
};
</script>
<style scoped>
.form-inline-pesquisa{
  margin-top:15px;
  text-align: left;
  padding-left: 50px;;
}

</style>